<div class="container mx-auto mt-5 px-4">
  <h2 class="text-3xl font-semibold text-center mb-6">
    Instituciones Educativas
  </h2>
  <div class="flex justify-between items-center mb-4">
    <button
      (click)="goBack()"
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
    >
      Volver
    </button>
    <button
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="goToCreateInstitucion()"
    >
      Registrar Institucion
    </button>
    <button
      class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
      (click)="goToCreateInstituciones()"
    >
      Subir Instituciones
    </button>
  </div>
  <app-table
    [data]="instituciones"
    [columns]="columns"
    [actions]="actions"
    searchPlaceholder="Nombre o Código"
  ></app-table>

  <app-item-modal
    [isOpen]="showModal"
    [item]="selectedItem"
    [title]="'Editar Institucion'"
    [fields]="fields"
    (close)="showModal = false"
    (save)="saveChanges($event)"
  ></app-item-modal>
</div>
